import { defineComponent as _defineComponent } from 'vue'
import { Icon, Typo } from '@travelata-libs/ui-kit';
  import { FREE_CANCELLATION_LABEL_TEXT } from '../config';

export default /*#__PURE__*/_defineComponent({
  __name: 'FreeCancellationLabel',
  setup(__props) {

  
return { __sfc: true,Icon, Typo, FREE_CANCELLATION_LABEL_TEXT }
}

})